<template>
  <div class="bigbox" v-if="hasInner">
    <div class="bg_img" :style="{backgroundImage:`url(${detailData.background_img})`,backgroundColor:`${detailData.background_color}`}"></div>
    <div class="valuebox">
      <div class="tishi">
        <div class="left">
          <div class="rank" @click="upStatus(true)">
            <img class="jiang" src="@/assets/img/rank.svg" />
            <div>Rank List</div>
          </div>
          <div class="left-jieshi">Flip cards and find the pairs!</div>
        </div>
        <div class="right">
          <div class="nowtime">Time: {{str}}</div>
          <div class="besttime">Your best time: {{besttime}}</div>
        </div>
      </div>
      <ul class="gameTab father">
          <li
          :class="isRotate ? 'rotate' : ''"
          v-for="img in imgs"
          :key="img.id"
          @click="flip(img)"  
          ref="card"
          >
            <div class="li_inner">
              <img :src="img.img" class="card front"  ref="cardz" />    <!-- 卡片正面图片  -->
              <div class="card back" ref="cardf" :style="{backgroundImage: 'url(' + gezi_background + ')'}"></div>         <!-- 卡片背面背景  -->
            </div>
          </li>
      </ul>
      <div class="buttons">
        <img class="start" @click="startFun" v-show="!isAgain" src="@/assets/img/poker_start.png" />
        <img class="start" @click="startFun" v-show="isAgain" src="@/assets/img/poker_again.png" />
        <!-- <div class="start" @click="startFun" v-show="!isAgain">Start</div>
        <div class="start" @click="startFun" v-show="isAgain">Again</div> -->
      </div>
      <div class="adver">
        <img :src="detailData.brief_img">
      </div>
      <div class="rules" v-if="rules.length!=0">
        <div class="rules-title">Rules:</div>
        <div class="rules-content" v-for="(rule,index) in rules" :key="index">
          <div class="rules-detail" v-html="rule"></div>
        </div>
      </div>
      <Rank ref="rankChild" v-if="showRank" v-on:statusChanged="upStatus($event)" />
      <Form ref="formChild" v-if="showForm" :hasPrize="hasPrize" :rankIndex="rankIndex" :time="str" :submitTime="submittime" :showForm="showForm" @changeShowForm="showformFun" />
    </div>
  </div>
</template>
<script>
import Rank from "@/components/rank.vue";
import Form from "@/components/form.vue";
import { getMyRank, submitAddTime, getPuzzleConfigure, getCurrentRank, getCurrentRank1 } from "@/util/data.js";
import { showToast } from "@/util/utils.js";
export default {
  components: {
    Rank,Form
  },
  data() {
    return {
      imgs:[],
      isStart:false, //是否开始游戏
      isRotate:false,
      ids:[],
      success:0,
      showRank:false,
      showForm:false,
      hour:0,//定义时，分，秒，毫秒并初始化为0；
      minute:0,
      second:0,//秒
      ms:0,//毫秒
      time:'',
      str:'00:00.00',
      hasInner:false,
      detailData:{},
      rules:[],
      images:[],
      isActivityFlag:false,
      submittime:null, //要提交到接口的时间
      besttime:"00:00.00",
      isAgain:false,
      hasPrize:true, //是否有奖品
      rankIndex:'',
      gezi_background:"http://sanyglobal-com.oss-cn-hongkong.aliyuncs.com/market/poker_default.jpg",
    };
  },
  created() {
    this.getConfigure();
    let token=this.$store.state.token || window.localStorage.getItem("token");
    if(token){
      this.getMyrank(); 
    }
  },
  mounted () {

  },
  computed: {
  	token: function() {
  		return this.$store.state.token || window.localStorage.getItem("token");
  	}
  },
  watch: {
  	token(){
  		let token=this.$store.state.token || window.localStorage.getItem("token");
  		if(token){ this.getMyrank(); }
  	}
  },
  methods: {
    //将图片数组整理成我想要的格式
    update_template(arr){
      var new_arr=[]
      const len = new_arr.length;
      for(var i in arr){
        var json={
          "id":parseInt(i)+1,
          "is_sign":parseInt(i)+1,
          "img":arr[i]
        }
        new_arr.push(json);
        if(i==(arr.length - 1)){
          for(var j in new_arr){
            new_arr.push({
              id:parseInt(len) +j,
              is_sign:new_arr[j].is_sign,
              img:new_arr[j].img
            });
            if(j==((new_arr.length / 2) - 1)){
              this.randomRender(new_arr);
            }
          }
        }
      }
    },
    // 随机图片位置
    randomRender(imgs) {
      let results = [];
      results = imgs.sort(() => {
        return Math.random() > 0.5 ? -1 : 1;
      });
      for(var i in results){
        results[i].id=parseInt(i)+1;
        if(i==(results.length - 1)){
          this.imgs = results;
          this.hasInner=true;
        }
      }
    },
    // 点击翻牌
    flip(img) {
      // 判断是否点击开始游戏
      if (this.isStart) {
        //判断当前的牌是否已经被点开过了
        var index = parseInt(img.id) - 1;
        const ele = this.$refs.card[index];
        if(ele.className=='rotate'){
          return;
        }
        // 初始在data中定义空数组 ids；
        // 判断是否连续点击相同的牌 不同时添加到数组中
        if (img !== this.ids[0]) {
          // 翻转卡片
          this.$refs.cardz[img.id - 1].style.transform = "rotateY(0)";
          this.$refs.cardf[img.id - 1].style.transform = "rotateY(180deg)";
          this.ids.push(img);
        }
        // 当已经存进两张卡片时，去判断两张是否配对，如配对成功就将两张卡片消失，并记录一次
        if (this.ids.length == 2) {
          //匹配成功
          if (this.ids[0].is_sign === this.ids[1].is_sign) {
            for (let i = 0; i < this.ids.length; i++) {
              this.$refs.card[this.ids[i].id - 1].className = "rotate";
              this.$refs.cardz[this.ids[i].id - 1].style.transform = "rotateY(0deg)";
              this.$refs.cardf[this.ids[i].id - 1].style.transform = "rotateY(180deg)";
            }
            this.ids.splice(0, 2);
            // 配对成功记录一次  当success = 10 时 挑战成功
            this.success++;
            if (this.success == (this.imgs.length / 2)) {
              showToast(this, "Success");
              this.stop(); //时间暂停
              this.successFun();
              clearInterval(this.timer);
              // 游戏成功 关闭计时器 展示成功弹窗
            }
          }else{ //匹配不成功
            for (let i = 0; i < this.ids.length; i++) {
              let vm = this;
              setTimeout(function(){
                if(vm.ids[i]){
                  vm.$refs.cardz[vm.ids[i].id - 1].style.transform = "rotateY(180deg)";
                  vm.$refs.cardf[vm.ids[i].id - 1].style.transform = "rotateY(0)";
                }
                if(i==1){
                  vm.ids.splice(0, 2);
                }
              },500)
            }
          }
        } 
        else if (this.ids.length > 2) {
          // 若前两张未配对成功 当翻开三张牌时 让前两张翻过去 并将数组中这俩卡片数据删除
          let x = this.ids.find((value, index, arr) => {
            if (index < 2) {
              return arr[index] == img;
            }
          });
          if (x == undefined) {
            for (let i = 0; i < this.ids.length - 1; i++) {
              this.$refs.cardz[this.ids[i].id - 1].style.transform =
                "rotateY(180deg)";
              this.$refs.cardf[this.ids[i].id - 1].style.transform =
                "rotateY(0)";
            }
            this.ids.splice(0, 2);
          } else {
            this.ids.splice(this.ids.length - 1, 1);
          }
        }
      } else {
        showToast(this, "Please click start");
      }
    },
    timeStart(){
      this.time =setInterval(this.timer,10)
    },
    timer () {//定义计时函数
      this.ms =this.ms +10        //毫秒
      if (this.ms >=1000) {
        this.ms =0
        this.second =this.second +1        //秒
      }
      if (this.second >=60) {
        this.second =0
        this.minute =this.minute +1        //分钟
      }
      if (this.minute >=60) {
        this.minute =0
        this.hour =this.hour +1        //小时
        this.stop(); //超时暂停时间
      }
      this.str =this.toDub(this.minute) +':' +this.toDub(this.second)+"."+this.toDubms(this.ms);
      if(this.minute==59&&this.second==59){
        this.stop();
      }
    },
    toDub (n) {//补0操作
      if (n <10) {return '0' + n}
      else {return '' + n}
    },
    toDubms(num){
      var data=num/10;
      return data;
    },
    stop () {
      clearInterval(this.time)
    },
    reset () {//重置
      clearInterval(this.time)
      this.hour =0
      this.minute =0
      this.ms =0
      this.second =0
      this.str ='00:00:00'
    },
    getConfigure() {
      getPuzzleConfigure({id:this.$route.params.id})
      .then((res) => {
        if (res.code === 1) {
          if(res.data==null||res.data.template_id!=2){  
            // 该活动不存在
            this.hasInner=false;
            return;
          }
          this.detailData=res.data;
          if(res.data.poker_img) this.gezi_background = res.data.poker_img;
          if(res.data.rules!="") this.rules = res.data.rules.split('\n');
          this.images = JSON.parse(res.data.images);
          this.update_template(this.images);
          res.data.start_time = res.data.start_time.replace(/-/g,"/");
          res.data.end_time = res.data.end_time.replace(/-/g,"/");
          var start = new Date(res.data.start_time).getTime();
          var end = new Date(res.data.end_time).getTime();
          var now = Date.parse(new Date());
          if (now >= start && now <= end) {
              this.isActivityFlag = true;
            } else if (now < start) {
              this.isActivityFlag = 0;
            } else this.isActivityFlag = -1;
          if(res.data.brief_img==""){
            this.hasPrize = false;
          }
        } else {
          var msg=res.message||res.msg||"Fail!";
          showToast(this, msg);
        }
      })
      .catch((err) => {
        console.log("getPuzzleConfigure catch error")
      });
    },
    startFun(){
    	if (!this.isActivityFlag) {
        showToast(this, "The game hasn't started yet.");
        return;
      } else if (this.isActivityFlag === -1) {
        showToast(this, "The game is already over.");
        return;
      }
    	let token =this.$store.state.token || window.localStorage.getItem("token");
      if (this.detailData.is_validate_login==1&&!token) { //后台若选择登录验证，则需登录才可以玩游戏
        this.$store.commit("updateLoginState", true);
        return;
      }
      else if(!this.isStart) {
        this.isStart=true;
        this.reset();
        this.timeStart();
      }
      if(this.isAgain){
        this.reset();
        this.timeStart();
        this.ids = [];
        this.success = 0;
        //location.reload();
        this.randomRender(this.imgs);
        for(var i in this.imgs){
          this.$refs.cardz[i].style.transform = "rotateY(180deg)";
          this.$refs.cardf[i].style.transform = "rotateY(0)";
          this.$refs.card[i].className = "";
        }
      }
    },
    successFun(){
      var time=(this.minute*60)+this.second;
      time=time+"."+this.ms;
      time=parseFloat(time);
      this.submittime = time;
      
      let token=this.$store.state.token || window.localStorage.getItem("token") || "no";
      getCurrentRank({
        cost_time:time,
        activity_id:this.$route.params.id
      },token)
      .then((res) => {
        if (res.code === 1) {
          this.isAgain=true;
          this.rankIndex = res.data.rank;
          this.showForm=true;
          this.getMyrank();
          this.$refs.rankChild.getRanks(); //游戏成功，提交成功，刷新排行榜
          this.$refs.formChild.getMyrank(); //游戏成功，提交成功，刷新个人排名
        } else {
          var msg=res.message||res.msg||"Fail!";
          showToast(this, msg);
        }
      })
      .catch((err) => {
        //showToast(this, "Fail!");
      });
    },
    showformFun(val){
      this.showForm = false;
    },
    upStatus(status){
      this.showRank=status;
    },
    getMyrank(){
      let token =this.$store.state.token || window.localStorage.getItem("token");
      if (token) {
        getMyRank({
          activity_id:this.$route.params.id
        },token)
        .then((res) => {
          if (res.code === 1) {
            if(res.data.score!=-1){
              this.dealTime(res.data.score);
            }
          } else {
            var msg=res.message||res.msg||"Fail!";
            showToast(this, msg);
          }
        })
        .catch((err) => {
          //showToast(this, "Fail!");
        });
      }
    },
    dealTime(data){
      var time=data+"";
      var timeArr=time.split('.');
      var num=parseFloat(timeArr[0]);
      var str=""; var str1=""; var str2=""; var str3="";
      if(num>60){
        if((Math.floor(num /60))<10){
          str1="0"+Math.floor(num /60);
        }
        if((Math.floor(num /60))>=10){
          str1=Math.floor(num /60);
        }
        if(num %60<10){
          str2="0"+(num %60);
        }
        if(num %60>=10){
          str2=(num %60);
        }
        str=str1+":"+str2;
      }else{
        if(num<10){
          str2="0"+timeArr[0];
        }
        if(num>=10){
          str2=timeArr[0];
        }
        str="00:"+str2;
      }
      if(timeArr[1]) { 
        // 先判断字符串的个数
        if(timeArr[1].length==1){
          str=str+"."+timeArr[1]+"0";
        }else if(timeArr[1].length==2){
          str=str+"."+timeArr[1];
        }
      }
      else { str=str+".00"; }
      this.besttime=str;
    }
  }
    
};
</script>
<style lang="scss" scoped>
// 消失动画
@keyframes vanish {
  0% {
    transform: rotate(0deg) scale(1);
    opacity: 1;
  }
  100% {
    transform: rotate(0deg) scale(1);
    opacity: 1;
    // transform: rotate(360deg) scale(0);
    // opacity: 0;
  }
}
.gameTab {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    width: 100%;
    margin: 20px auto 20px auto;
    .rotate {
        animation: vanish 0.5s forwards;
    }
    li {
        width: calc((100% - 15px) / 4);
        // width: calc((100% - 10px) / 3);
        margin-bottom: 5px;
        position: relative;
        cursor: pointer;
        perspective: 800px;
        .li_inner{
          width: 100%;
          height: 0;
          position: relative;
          padding-bottom: 100%;
          img{
            border-radius: 5px;
          }
          .card {
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            color: #fff;
            line-height: 130px;
            text-align: center;
            cursor: pointer;
            transition: 0.3s ease-in-out;
            backface-visibility: hidden;
            -webkit-backface-visibility: hidden;
          }
          .front {
            background-color: #3949c0;
            z-index: 2;
            transform: rotateY(-180deg);
          }
          .back {
            // background: url('http://sanyglobal-com.oss-cn-hongkong.aliyuncs.com/market/poker_default.jpg') no-repeat;
            background-size: 100% 100%;
            z-index: 1;
            transform: rotateY(0);
            border-radius: 5px;
          }
        }
    }
}
.valuebox{
  width: calc(100% - 20px);
}
.buttons .start{
  display: block;
  width: 130px;
  cursor: pointer;
  margin: 32px auto 23px auto;
  // height: 43px;
  // border: 1px solid #ffd86f;
  // border-radius: 5px;
  // font-size: 20px;
  // color: white;
  // text-align: center;
  // line-height: 43px;
}
.adver,.adver img{
  width: 100%;
}
.rules{
  margin: 30px 0;
  line-height: 20px;
}
.rules .rules-title{
  font-weight: 700;
  color: #ffc84d;
  font-size: 22px;
  margin-bottom: 12px;
}
.rules-content{
  color: white;
  opacity: 0.7;
  font-size: 14px;
}
.tishi{
  // overflow:hidden;
  // margin-bottom: 30px;
  margin: 10px 0 90px 0;
}
.tishi .left{
  font-weight: 700;color: #ffc84d;float: left;
  margin-top: -9px;
}
.tishi .left .rank{
  overflow: hidden;cursor: pointer;margin-bottom: 15px;
}
.tishi .left .rank img{
  float: left;width: 30px;margin-right: 15px;
}
.tishi .left .rank div{
  float: left;font-size: 20px;
  margin-top: 9px;
}
.left-jieshi{
  opacity: 0.7;
  font-size: 14px;
  font-weight: 400;
  color: #ffffff;
}
.tishi .right{
  float: right;
}
.tishi .right .nowtime{
  font-size: 21px;
  font-weight: 700;
  color: #ffc84d;
  text-align: left;
  margin-bottom: 15px;
  white-space: nowrap
}
.tishi .right .besttime{
  opacity: 0.7;
  font-size: 14px;
  font-weight: 400;
  color: #ffffff;
  // text-align: right;
  text-align: left;
}
.valuebox{
  max-width: 500px;
}
@media screen and (max-width: 768px){
  .gameTab li{
    width: calc((100% - 10px) / 3);
  }
  .tishi{
    // margin-bottom: 25px;
    margin: 5px 0 70px 0;
  }
  .tishi .right .nowtime,.tishi .left .rank{margin-bottom: 8px;font-size: 20px;}
  .buttons .start{
    width: 145px;
    margin: 20px auto 15px auto;
  }
  .left-jieshi,.tishi .right .besttime{
    font-size: 12px;
  }
  .tishi .right .nowtime{
    width: 150px;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/Poker.vue